import './style.sass';

const md = require('markdown-it')({ breaks: true });

window.DatoCmsPlugin.init((plugin) => {
  /* eslint-disable prefer-arrow-callback */
  plugin.startAutoResizer();

  const container = document.createElement('div');
  container.classList.add('container');
  const button = document.createElement('button');
  button.innerHTML = 'View preview';
  const preview = document.createElement('div');
  preview.classList.add('editor-preview');
  if (plugin.getFieldValue(plugin.fieldPath) !== undefined) {
    preview.innerHTML = md.render(plugin.getFieldValue(plugin.fieldPath));
  }
  container.appendChild(button);
  container.appendChild(preview);
  document.body.appendChild(container);

  button.addEventListener('click', function () {
    if (preview.style.display === 'block') {
      preview.style.display = 'none';
      button.innerHTML = 'View preview';
    } else {
      preview.style.display = 'block';
      button.innerHTML = 'Close preview';
    }
  });

  plugin.addFieldChangeListener(plugin.fieldPath, (newValue) => {
    preview.innerHTML = md.render(newValue);
  });
});
